export enum RulesTypeModel {
    ROOM_TYPE = "room_type",
    NIGHTS = "nights",
    DATE_RANGE = "date_range",
}